export const IssuersBrands = {
  MASTERCARD: [
  "CARREFOUR",
  "COMAFI",
  "LETSBIT",
  "SILOHUB",
  "SMSV",
  "UNIRED",
  "FRAVEGA"
  ],
  VISA: [
    "XPERIENCE",
    "LINKING_POS",
    "PROPAGO",
    "COINAG",
    "POLLUX",
    "PAGO24",
    "AL2",
    "NUBI",
    "LATIN_PAY",
    "CREDINOS",
    "PAGOS_DIGITALES",
    "BANCO_FORMOSA",
    "ECOBRO"
  ]
}